module.exports = __webpack_public_path__ + "static/media/new_circle.6080a089.svg";